import {
  FormContainerWithHeader,
  FormTextField,
} from '../../../../presentation';

import { getFieldProps } from '@converge/data';
import { useTranslation } from 'react-i18next';

interface IProps {
  isReadonly: boolean;
}

export const UnderwritingOverviewUnderwritingDescriptionOfOperations = ({
  isReadonly,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <FormContainerWithHeader
      title={t(
        'underwriting.detail.content.sections.descriptionOfOperations.title',
        'Description of Operations'
      )}
    >
      <FormTextField
        {...getFieldProps('descriptionOfOperations', false, '')}
        containerWidth={12}
        isRichText
      />
    </FormContainerWithHeader>
  );
};
